import React from "react";
import styled from "styled-components";

const Root = styled.div``;
const Container = styled.div``;
const NftHeadingContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  align-items: flex-start;
  text-align: flex-start;
  border-radius: 10px;
  color: #fff;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  margin: 40px 0;
`;

const NftDetailsWrapper = styled.div`
  color: #fff;
  display: grid;
  margin-top: 20px;
  grid-template-columns: 20% 20% 20% 20% 20%;
  -webkit-box-align: center;
  align-items: flex-start;
  text-align: flex-start;
  padding: 0px 0px;
  box-shadow: 0px 0px 5px 5px #0000;
  border-radius: 5px;
`;

const HeadingText = styled.div``;
const NftDetails = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
`;

const RevenueTable = () => {
  return (
    <Root>
      <Container>
        <NftHeadingContainer>
          <HeadingText>Date</HeadingText>
          <HeadingText>Sold</HeadingText>
          <HeadingText>Auctioned</HeadingText>
          <HeadingText>Royality</HeadingText>
          <HeadingText>Transaction Fees</HeadingText>
        </NftHeadingContainer>

        <NftDetailsWrapper>
          <NftDetails> 08/05/2023 </NftDetails>
          <NftDetails> Alien Gun </NftDetails>
          <NftDetails> Rare </NftDetails>
          <NftDetails>$100</NftDetails>
          <NftDetails>$50</NftDetails>
        </NftDetailsWrapper>
      </Container>
    </Root>
  );
};

export default RevenueTable;
